module.exports = __webpack_public_path__ + "assets/24b72f8446bc4ce599189c772872c35b.jpg";